const styles = {
  familyImgStyle: {},
  familyIconStyle: {
    backgroundColor: "var(--green-900)",
  },
  snpIconStyle: {
    backgroundColor: "var(--orange-900)",
  },
  emptyStateStyles: {
    lineHeight: "2.4rem",
  },
  blue900BackgroundStyle: {
    backgroundColor: "var(--blue-900)",
  },
  pink900BackgroundStyle: {
    backgroundColor: "var(--pink-900)",
  },
  yellow900BackgroundStyle: {
    backgroundColor: "var(--yellow-900)",
  },
  orange900BackgroundStyle: {
    backgroundColor: "var(--orange-900)",
  },
  violet900BackgroundStyle: {
    backgroundColor: "var(--violet-900)",
  },
  green900BackgroundStyle: {
    backgroundColor: "var(--green-900)",
  },
  purple900BackgroundStyle: {
    backgroundColor: "var(--purple-900)",
  },
  teal900BackgroundStyle: {
    backgroundColor: "var(--teal-900)",
  },
  timetablePlannerWrapperStyle: {
    alignItems: "flex-start",
  },
  height100: {
    height: "100%",
  },
  timetablePlannerInnerContainerStyle: {
    minHeight: "100%",
    paddingBottom: 16,
  },
  widgetisedADMContainerStyle: {
    height: "100%",
    maxWidth: "unset",
  },
  assignmentAndDeadlineContainerStyle: {
    height: 500,
    maxWidth: "unset",
  },
  assignmentAndDeadlineContentStyle: {
    height: "calc(100% - 91px)", // 91px is the height of header
  },
  libraryCarouselContainerStyle: {
    marginBottom: 24,
  },
  demoDayBannerContainerStyle: {
    marginBottom: 0,
  },
  libraryCarouselWidgetContainerStyle: {
    marginBottom: 0,
    height: "100%",
  },
  libraryCardContainerStyle: {
    maxWidth: "unset",
  },
  assignmentAndDeadlineHeaderStyle: {
    position: "static",
  },
  timetableWidgetContainerStyle: {
    height: 500,
    margin: 0,
    backgroundColor: "var(--surface-primary-enabled)",
  },
};

export default styles;
